import {Component, Inject, OnInit} from '@angular/core';
import {ActivatedRoute} from "@angular/router";
import {NotificationsService, SpinnerComponent as Spinner} from '@westjetairlines/wjesd-component-library';
import {TravelCredit} from '../shared/models/travel-credit';
import {TRAVEL_CREDIT_SERVICE_TOKEN} from '../shared/services/travel-credit.service';

@Component({
  selector: 'app-summary',
  templateUrl: './summary.component.html',
  styleUrls: ['./summary.component.css']
})
export class SummaryComponent implements OnInit {
  travelCredits: Array<TravelCredit> = [];
  travelCredit: TravelCredit = new TravelCredit();
  constructor(@Inject(TRAVEL_CREDIT_SERVICE_TOKEN) private travelCreditService, private route: ActivatedRoute, private notificationService: NotificationsService) { }

  ngOnInit() {
    Spinner.start();
    var self = this;

    this.route.params.subscribe(p => {
      let transactionId = p['transactionid'];
      let travelCreditId = +p['id'];

      if (travelCreditId && travelCreditId > 0)
      {
        this.travelCreditService.getTravelCredit(travelCreditId).subscribe(result =>
          {
            if (!result.wasSuccessful)
            {
              this.notificationService.error(result.brokenRules[0].message);
              return;
            }

            self.travelCredits.push(result.value);
          },
          err => {
            Spinner.stop();
          },
          () => {
            Spinner.stop();
          });
      }
      else
      {
        this.travelCreditService.getTransaction(transactionId).subscribe(result =>
        {
          if (!result.wasSuccessful)
          {
            this.notificationService.error(result.brokenRules[0].message);
            return;
          }

          self.travelCredits.push(...result.value);
        },
        err => {
          Spinner.stop();
        },
        () => {
          Spinner.stop();
        });
      }
    });
  }

  ngOnDestroy() {
    this.notificationService.clear();
  }

  getCommonTravelCredit() : TravelCredit {
    if (this.travelCredits && this.travelCredits.length == 0)
      return new TravelCredit();

    return this.travelCredits[0];
  }

}



// WEBPACK FOOTER //
// ./src/app/summary/summary.component.ts